























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import * as user from "@/_store/user.module";
import * as images from "../../assets/images";
import DocReviewDialog from "../Dialogs/DocReviewDialog.vue";
import DocSignDialog from "../Dialogs/DocSignDialog.vue";
import { bus } from "../../main";
import QuestionarioDialog from "../Dialogs/QuestionarioDialog.vue";
import FoglioFirmeDialog from "../Dialogs/FoglioFirmeDialog.vue";
import { UserInfo } from "@/_models/userInfo";

@Component({
	components: {
		DocReviewDialog,
		DocSignDialog,
		QuestionarioDialog,
		FoglioFirmeDialog
	}
})
export default class AlternanzaDoc extends Vue {
	@Prop() idRichiesta!: number;
	@Prop() activityType!: string;
	@Prop() soggetto!: string; //entità che visualizza l'elenco documenti
	@Prop() statoAttivita!: number;
	@Prop() tipoQuestionario!: string;
	@Prop() info!: any;

	private show: boolean;
	private convenzione: any;
	private convenzioneDigitale: any;
	private pattoFormativo: any;
	private percorsoFormativo: any;
	private percorsoFormativoDigitale: any;
	private attestatoFinale: any;
	private questionario: any;
	private questionario2: any;
	private foglioFirme: any;
	private docDVR: any;
	private docType: string;
	private idTipoDocumentoSelected: number;

	private wrapperIdRichiesta: any;
	private wrapperDialogTitle: any;

	private loadingConvenzioneReview: boolean;
	private loadingPattoFormativoReview: boolean;
	private loadingPercorsoFormativoReview: boolean;
	private loadingAttestatoFinaleReview: boolean;
	private loadingQuestionarioReview: boolean;
	private loadingFoglioFirme: boolean;
	private loadingConfermaOrari: boolean;
	private loadingRifiutaOrari: boolean;

	private userRole: any;

	constructor() {
		super();
		this.show = true;
		this.convenzione = {};
		this.convenzioneDigitale = {};
		this.pattoFormativo = {};
		this.percorsoFormativo = {};
		this.percorsoFormativoDigitale = {};
		this.attestatoFinale = {};
		this.questionario = {};
		this.questionario2 = {};
		this.foglioFirme = {};
		this.docDVR = {};
		this.docType = "";
		this.idTipoDocumentoSelected = 0;

		this.wrapperIdRichiesta = {
			idRichiesta: this.idRichiesta
		};
		this.wrapperDialogTitle = {
			title: "QUESTIONARIO FSL Estiva"
		};

		this.loadingConvenzioneReview = false;
		this.loadingPattoFormativoReview = false;
		this.loadingPercorsoFormativoReview = false;
		this.loadingAttestatoFinaleReview = false;
		this.loadingQuestionarioReview = false;
		this.loadingFoglioFirme = false;
		this.loadingConfermaOrari = false;
		this.loadingRifiutaOrari = false;
	}

	openConvenzione() {
		this.loadingConvenzioneReview = true;
		this.docType = "convenzione";
		bus.$emit("openDocConvenzioneReview", this.convenzione);
	}

	openPattoFormativo() {
		this.loadingPattoFormativoReview = true;
		this.docType = "pattoFormativo";
		bus.$emit("openDocPattoFormativoReview", this.pattoFormativo);
	}

	openPercorsoFormativo() {
		this.loadingPercorsoFormativoReview = true;
		this.docType = "percorsoFormativo";
		bus.$emit("openDocPercorsoFormativoReview", this.percorsoFormativo);
	}

	openAttestatoFinale() {
		this.loadingAttestatoFinaleReview = true;
		this.docType = "attestatoFinaleAlternanza";
		bus.$emit("openDocAttestatoFinaleAlternanzaReview", this.attestatoFinale);
	}

	openQuestionario(tipoQuestionario: string) {
		if (this.soggetto === "istituto") {
			if (tipoQuestionario === "questionarioTirocinante") {
				this.loadingQuestionarioReview = true;
				this.docType = "questionarioTirocinante";
				bus.$emit("openDocQuestionarioReview", this.questionario);
			} else if (tipoQuestionario === "questionarioAzienda") {
				this.loadingQuestionarioReview = true;
				this.docType = "questionarioAzienda";
				bus.$emit("openDocQuestionarioReview", this.questionario2);
			}
		} else if (this.soggetto === "azienda") {
			this.loadingQuestionarioReview = true;
			this.docType = "questionarioAzienda";
			bus.$emit("openDocQuestionarioReview", this.questionario);
		} else if (this.soggetto === "allievo") {
			this.loadingQuestionarioReview = true;
			this.docType = "questionarioTirocinante";
			bus.$emit("openDocQuestionarioReview", this.questionario);
		} else if (this.soggetto === "tutorAziendale") {
			this.loadingQuestionarioReview = true;
			this.docType = "questionarioAzienda";
			bus.$emit("openDocQuestionarioReview", this.questionario);
		}
	}

	openFoglioFirme() {
		this.loadingAttestatoFinaleReview = true;
		this.docType = "foglioFirme";
		bus.$emit("openDocFoglioFirmeReview", this.foglioFirme);
	}

	openDocDVR() {
		this.docType = "docDVR";
		bus.$emit("openDocDVRReview", this.docDVR, this.info);
	}

	async loadConvenzione() {
		const payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType
		};

		try {
			const convenzione = await data.dispatchConvenzioneAttivita(this.$store, payload);
			this.convenzione = convenzione;
			const convenzioneDigitale = await data.dispatchConvenzioneDigitale(this.$store, payload);
			this.convenzioneDigitale = convenzioneDigitale || {};
			return convenzioneDigitale;
		} catch (error) {
			// if (error.response.status === 403) {
			//   bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
			//   this.$router.push("/login");
			// } else {
			//   bus.$emit("errorOperation", error.response?.statusText || "Errore sconosciuto");
			// }
			throw error
		}
	}

	// async loadConvenzione() {
	//   var payload = {
	//     idRichiesta: this.idRichiesta,
	//     activityType: this.activityType
	//   };
	//   data
	//     .dispatchConvenzioneAttivita(this["$store"], payload)
	//     .then(result => {
	//       this.convenzione = result;
	//       data
	//         .dispatchConvenzioneDigitale(this["$store"], payload)
	//         .then(result => {
	//           console.log('convenzione',result)
	//           if(result == undefined){
	//             this.convenzioneDigitale = {};
	//           }else{
	//             this.convenzioneDigitale = result;
	//           }
	//         })
	//         .catch(error => {
	//           if (error.response.status === 403) {
	//             bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//             this["$router"].push("/login");
	//           } else {
	//             bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//           }
	//         });
	//     })
	//     .catch(error => {
	//       if (error.response.status === 403) {
	//         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//         this["$router"].push("/login");
	//       } else {
	//         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//       }
	//     });
	// }

	loadPattoFormativo() {
		var payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType
		};
		data
			.dispatchPattoFormativo(this["$store"], payload)
			.then(result => {
				this.pattoFormativo = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	async loadPercorsoFormativo() {
		const payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType
		};

		try {
			const percorsoFormativo = await data.dispatchPercorsoFormativo(this.$store, payload);
			this.percorsoFormativo = percorsoFormativo;
			var percorsoDigitale = {};
			if (this.soggetto !== "tutorAziendale") {
				percorsoDigitale = await data.dispatchPercorsoFormativoDigitale(this.$store, payload) || {};
			}else{
				this.percorsoFormativoDigitale =  {};
			}

			return percorsoDigitale;
		} catch (error) {
			// if (error.response?.status === 403) {
			//   bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
			//   this.$router.push("/login");
			// } else {
			//   bus.$emit("errorOperation", error.response?.statusText || "Errore sconosciuto");
			// }
			throw error;
		}
	}

	// async loadPercorsoFormativo() {

	//   var payload = {
	//     idRichiesta: this.idRichiesta,
	//     activityType: this.activityType
	//   };
	//   data
	//     .dispatchPercorsoFormativo(this["$store"], payload)
	//     .then(result => {
	//       this.percorsoFormativo = result;
	//       data.dispatchPercorsoFormativoDigitale(this["$store"], payload)
	//         .then(result => {
	//           console.log('percorso',result)
	//           if(result == undefined){
	//             this.percorsoFormativoDigitale = {};
	//           }else{
	//             this.percorsoFormativoDigitale = result;
	//           }
	//         }).catch(error => {
	//           if (error.response.status === 403) {
	//             bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//             this["$router"].push("/login");
	//           } else {
	//             bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//           }
	//         });
	//     })
	//     .catch(error => {
	//       if (error.response.status === 403) {
	//         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//         this["$router"].push("/login");
	//       } else {
	//         bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
	//       }
	//     });
	// }

	loadAttestatoFinale() {
		var payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType
		};
		data
			.dispatchAttestatoFinaleInfo(this["$store"], payload)
			.then(resp => {
				this.attestatoFinale = resp;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	loadQuestionario() {
		var payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType,
			tipoQuestionario: this.tipoQuestionario
		};
		if (this.tipoQuestionario === "questionariSoddisfacimento") {
			payload.tipoQuestionario = "questionarioTirocinante";
			data
				.dispatchRisposteQuestionario(this["$store"], payload)
				.then(result => {
					this.questionario = result;
					payload.tipoQuestionario = "questionarioAzienda";
					data
						.dispatchRisposteQuestionario(this["$store"], payload)
						.then(result2 => {
							this.questionario2 = result2;
						})
						.catch(error => {
							if (error.response.status === 403) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		} else {
			data
				.dispatchRisposteQuestionario(this["$store"], payload)
				.then(result => {
					this.questionario = result;
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}
	}

	loadFoglioFirme() {
		var payload = {
			idRichiesta: this.idRichiesta,
			activityType: this.activityType
		};
		data
			.dispatchElencoFirme(this["$store"], payload)
			.then(result => {
				this.foglioFirme = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	loadDocDVR() {
		data
			.dispatchDocDVR(this["$store"], this.idRichiesta)
			.then(result => {
				this.docDVR = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	uploadDocumento(pdfBase64: any) {
		var idActivityType: number = 0;

		if (this.activityType === 'tirocinioEstivo') {
			idActivityType = 1
		} else if (this.activityType === 'alternanza') {
			idActivityType = 2
		} else if (this.activityType === 'tirocinioFormativo') {
			idActivityType = 4
		} else if (this.activityType === 'tirocinioReIns') {
			idActivityType = 6
		}

		if (this.idTipoDocumentoSelected === 8) {
			var payloadDVR = {
				idRichiesta: this.idRichiesta,
				base64: pdfBase64
			};

			user.dispatchUploadDocDVR(this["$store"], payloadDVR)
				.then(result => {
					bus.$emit("loadPreAssegnazioni");
					bus.$emit("successfullOperation", "Documento DVR caricato con successo");
					this.loadDocDVR();
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server' || "Errore durante il caricamento del DVR");
					}
				});
			return;
		} else {
			var payload = {
				idTipoDocumento: this.idTipoDocumentoSelected,
				idTipoAttivita: idActivityType,
				tipoAttivita: this.activityType,
				idRichiesta: this.idRichiesta,
				base64: pdfBase64
			};

			user
				.dispatchUploadDocumento(this["$store"], payload)
				.then(async result => {
					bus.$emit("loadPreAssegnazioni");
					if (this.idTipoDocumentoSelected === 1) {
						await this.loadConvenzione()
						if (this.soggetto == "istituto") {
							if ((this.convenzioneDigitale.id != undefined && this.convenzioneDigitale.idTipoSoggetto == 2) && (this.percorsoFormativoDigitale.id != undefined && this.percorsoFormativoDigitale.idTipoSoggetto == 2)) {
								this.sendEmail()
							}
						} else if (this.soggetto == "azienda") {
							if ((this.convenzioneDigitale.id != undefined && this.convenzioneDigitale.idTipoSoggetto == 3) && (this.percorsoFormativoDigitale.id != undefined && this.percorsoFormativoDigitale.idTipoSoggetto == 3)) {
								this.sendEmail()
							}
						}
						bus.$emit(
							"successfullOperation",
							"Convenzione caricata con successo"
						);
					} else if (this.idTipoDocumentoSelected === 3) {
						await this.loadPercorsoFormativo()
						if (this.soggetto == "istituto") {
							if ((this.convenzioneDigitale.id != undefined && this.convenzioneDigitale.idTipoSoggetto == 2) && (this.percorsoFormativoDigitale.id != undefined && this.percorsoFormativoDigitale.idTipoSoggetto == 2)) {
								this.sendEmail()
							}
						} else if (this.soggetto == "azienda") {
							if ((this.convenzioneDigitale.id != undefined && this.convenzioneDigitale.idTipoSoggetto == 3) && (this.percorsoFormativoDigitale.id != undefined && this.percorsoFormativoDigitale.idTipoSoggetto == 3)) {
								this.sendEmail()
							}
						}
						bus.$emit(
							"successfullOperation",
							"Progetto formativo caricato con successo"
						);
					}
				})
				.catch(error => {
					if (error.response.status === 403) {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
						this["$router"].push("/login");
					} else {
						bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					}
				});
		}

	}

	sendEmail() {
		var tipoSoggettoEmail: string = "";

		if (this.soggetto == "istituto") {
			tipoSoggettoEmail = "azienda"
		} else if (this.soggetto == "azienda") {
			tipoSoggettoEmail = "allievo"
		}

		var payload = {
			emailAzienda: this.info.emailAzienda,
			emailTirocinante: this.info.emailUtente,
			denominazioneAzienda: this.info.denominazioneAzienda,
			tirocinante: this.info.allievo,
			tipoSoggetto: tipoSoggettoEmail
		}

		user
			.dispatchSendEmailFirmaDocAlternanza(this["$store"], payload)
			.then(() => {

			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	async handleFileUpload(event: any) {
		const file = event.target.files[0];

		// Check if a file is selected
		if (!file) {
			console.error("Nessun file selezionato.");
			return;
		}

		// Check file type
		if (file.type !== "application/pdf") {
			alert("Il file selezionato non è un PDF. Riprova.");
			return;
		}

		const base64File = await this.convertToBase64(file);

		this.uploadDocumento(base64File)
	}

	uploadFile(idTipoDocumento: number) {
		this.idTipoDocumentoSelected = idTipoDocumento
		let fileInput = document.getElementById('fileInput')
		if (fileInput) {
			fileInput.click()
		}
	}

	downloadFileDVR() {
		if (this.docDVR && this.docDVR.idDocDVR) {
			const base64Data = "data:application/pdf" + ";base64," + this.docDVR.allegato
			const a = document.createElement('a')
			a.href = base64Data
			a.download = 'DVR_' + this.docDVR.idDocDVR + '.pdf'
			a.style.display = 'none'
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		}
	}

	downloadFile(idDocumento: number, idTipoDocumento: number) {
		let cognomeTirocinante = this.percorsoFormativo.tirocinante.trim().replace(/\s+/g, '_')
		let classeTirocinante = this.percorsoFormativo.classeTirocinante.trim().replace(/\s+/g, '')
		let nomeAzienda = this.convenzione.denominazioneAzienda.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, '').trim().replace(/\s+/g, '_').replace(/_+/g, '_').replace(/_+$/g, '')
		let tipoDoc = ''
		var payload = {
			idDocumento: idDocumento
		}
		data.dispatchDocDigitaleById(this["$store"], payload)
			.then((result) => {
				const base64Data = "data:application/pdf" + ";base64," + result.base64

				if (idTipoDocumento == 1) {
					tipoDoc = 'Conv'
				} else if (idTipoDocumento == 3) {
					tipoDoc = 'PFI'
				}

				const a = document.createElement('a')
				a.href = base64Data
				a.download = cognomeTirocinante + '_' + classeTirocinante + '_' + tipoDoc + '_' + nomeAzienda

				a.style.display = 'none'

				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
			})
	}

	confirmConvenzione() {
		var payload = {
			idConvenzione: this.convenzione.idConvenzione
		};
		user
			.dispatchConfermaConvenzioneAlternanza(this["$store"], payload)
			.then(result => {
				this.loadConvenzione();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Convenzione confermata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	refuseConvenzione() {
		var payload = {
			idConvenzione: this.convenzione.idConvenzione
		};
		user
			.dispatchRefuseConvenzioneAlternanza(this["$store"], payload)
			.then(result => {
				this.loadConvenzione();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Convenzione rifiutata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	confirmPercorso() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo
		};
		user
			.dispatchConfirmPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Progetto formativo confermato con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	refusePercorso() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo
		};

		user
			.dispatchRefusePercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Progetto formativo rifiutato con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	confirmFirmaTirocinante() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaTirocinante: 2
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma tirocinante confermata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	refuseFirmaTirocinante() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaTirocinante: 3
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma tirocinante rifiutata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	confirmFirmaAzienda() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaAzienda: 2
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma azienda confermata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	refuseFirmaAzienda() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaAzienda: 3
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma azienda rifiutata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	confirmFirmaTutorArticolazione() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaTutorArticolazione: 2
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma tutor articolazione confermata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	refuseFirmaTutorArticolazione() {
		var payload = {
			idPercorsoFormativo: this.percorsoFormativo.idPercorsoFormativo,
			idStatoFirmaTutorArticolazione: 4
		};
		user
			.dispatchUpdateStatoPercorsoFormativo(this["$store"], payload)
			.then(result => {
				this.loadPercorsoFormativo();
				bus.$emit("loadPreAssegnazioni");
				bus.$emit("successfullOperation", "Firma tutor articolazione rifiutata con successo");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	convertToBase64(file: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = () => {
				const result = reader.result as string;
				resolve(result.split(",")[1]);
			};
			reader.onerror = (error) => reject(error);

			reader.readAsDataURL(file);
		});
	}

	formatDateToLocale(dateString: string): string {
		if (!dateString) return '';

		try {
			// Se la data è già in formato DD/MM/YYYY, restituiscila così com'è
			if (dateString.includes('/') && dateString.length <= 10) {
				return dateString;
			}

			// Altrimenti, converte da ISO a formato locale
			const date = new Date(dateString);
			return date.toLocaleDateString('it-IT', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			});
		} catch (error) {
			return dateString; // Restituisce la data originale in caso di errore
		}
	}

	confirmOrariAllievo() {
		this.loadingConfermaOrari = true;

		user.dispatchConfirmOrariAllievo(this["$store"], this.info.IdInformazioneAlternanza)
			.then((result: any) => {
				this.loadingConfermaOrari = false;
				bus.$emit("successfullOperation", "Orari di lavoro confermati con successo");
				bus.$emit("loadActivityDocs");
			})
			.catch((error: any) => {
				this.loadingConfermaOrari = false;
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server' || "Errore durante la conferma degli orari");
				}
			});
	}

	refuseOrariAllievo() {
		this.loadingRifiutaOrari = true;

		user.dispatchRefuseOrariAllievo(this["$store"], this.info.IdInformazioneAlternanza)
			.then((result: any) => {
				this.loadingRifiutaOrari = false;
				// Aggiorna lo stato locale
				this.info.IdStatoAccettazioneAllievo = 3;
				bus.$emit("successfullOperation", "Orari di lavoro rifiutati");
				bus.$emit("loadActivityDocs");
			})
			.catch((error: any) => {
				this.loadingRifiutaOrari = false;
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server' || "Errore durante il rifiuto degli orari");
				}
			});
	}

	created() {
		if (this.soggetto !== "allievo") {
			var userInfo: UserInfo = user.readUserInfo(this["$store"]);
			this.userRole = userInfo.ruoloUtente;
		} else {
			this.userRole = 4
		}

		if (this.soggetto === "allievo") {
			this.loadPercorsoFormativo();
			this.loadPattoFormativo();
			if (this.statoAttivita === 4) {
				this.loadAttestatoFinale();
				this.loadQuestionario();
				this.loadFoglioFirme();
			}
		} else if (this.soggetto === "tutorAziendale") {
			this.loadPercorsoFormativo();
			if (this.statoAttivita === 4) {
				this.loadAttestatoFinale();
				this.loadQuestionario();
				this.loadFoglioFirme();
			}
		} else {
			if (this.statoAttivita === 4) {
				this.loadAttestatoFinale();
				this.loadQuestionario();
			}
			this.loadPercorsoFormativo();
			this.loadConvenzione();
			this.loadPattoFormativo();
			this.loadFoglioFirme();
			this.loadDocDVR();
		}

		bus.$on("loadConvenzione", () => {
			this.loadingConvenzioneReview = false;
			this.loadConvenzione();
		});

		bus.$on("loadPercorsoFormativo", () => {
			this.loadingPercorsoFormativoReview = false;
			this.loadPercorsoFormativo();
		});

		bus.$on("loadPattoFormativo", () => {
			this.loadingPattoFormativoReview = false;
			this.loadPattoFormativo();
		});

		bus.$on("loadAttestatoFinale", () => {
			this.loadingAttestatoFinaleReview = false;
			this.loadAttestatoFinale();
		});

		bus.$on("loadQuestionario", () => {
			this.loadingQuestionarioReview = false;
			this.loadQuestionario();
		});

		bus.$on("loadFoglioFirme", () => {
			this.loadingFoglioFirme = false;
			this.loadFoglioFirme();
		});

		bus.$on("loadDocDVR", () => {
			this.loadDocDVR();
		});

		bus.$on("closeDocReview", async () => {
			this.loadingConvenzioneReview = false;
			this.loadingPattoFormativoReview = false;
			this.loadingPercorsoFormativoReview = false;
			this.loadingAttestatoFinaleReview = false;
			this.loadingQuestionarioReview = false;
			this.loadingFoglioFirme = false;

			this.show = false;
			await this.$nextTick();
			this.show = true;
		});

		bus.$on("refreshDocs", () => {
			this.loadConvenzione();
			this.loadPercorsoFormativo();
			this.loadPattoFormativo();
			this.loadFoglioFirme();
			this.loadDocDVR();
			if (this.statoAttivita === 4) {
				this.questionario = [];
				this.loadAttestatoFinale();
				this.loadQuestionario();
			}
		});
	}
}
